import React, { Component } from 'react'
import SectionTitle from './../../section_title/SectionTitle'
import { reformatDashedDate } from './../../../utils/js/time_helpers'

import './SidebarHeadlines.scss'
import { preserveQueryParams } from 'utils/js/browser_helpers'

class SidebarHeadlines extends Component {
    static defaultProps = {
        zone_posts: {},
    }

    render() {
        const { zone_posts, noThumb } = this.props

        return (
            <div className="SidebarHeadlines__cont">
                <SectionTitle title="HEADLINES" />

                {(!zone_posts.headlines ||
                    !zone_posts.headlines.posts ||
                    zone_posts.headlines.posts.length === 0) && (
                    <div className="nodata">No Headlines Available</div>
                )}

                {zone_posts.headlines &&
                    zone_posts.headlines.posts &&
                    zone_posts.headlines.posts.length !== 0 && (
                        <div className="headlines_cont">
                            {zone_posts.headlines.posts.map(headline => {
                                const time = headline.post_date
                                    ? reformatDashedDate(headline.post_date.split(' ')[0])
                                    : ''

                                return (
                                    <a
                                        href={preserveQueryParams(headline.url)}
                                        className="headline"
                                        key={headline.ID}
                                    >
                                        {!noThumb && (
                                            <div
                                                className="post_thumbnail"
                                                style={{
                                                    backgroundImage: `url(${headline.featured_image_url})`,
                                                }}
                                            />
                                        )}
                                        <div className="post_info">
                                            <div className="post_header">
                                                {time && <div className="post_time">{time}</div>}
                                            </div>
                                            <div className="post_title">{headline.post_title}</div>
                                        </div>
                                    </a>
                                )
                            })}
                        </div>
                    )}
            </div>
        )
    }
}

export default SidebarHeadlines
